import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";

@Component({
  selector: "app-indications",
  imports: [CommonModule],
  template: `
    <p class="indications alert body-3" data-testid="exercise-indications">
      <img class="indications__icon" src="assets/icons/indications.svg" /><span class="indications__content"><ng-content /></span>
    </p>
  `,
  styles: `
    @use "responsive" as *;

    .indications {
      width: 100%;
    }

    .indications__icon {
      display: inline-block;
      width: 20px;
      height: 20px;
      margin-right: 12px;
      vertical-align: middle;
    }

    .indications__content {
      vertical-align: middle;
    }
  `,
})
export class Indications {}
